import React from 'react'
import MuiCheckbox from '@material-ui/core/Checkbox'
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';

import Dropdown from '@/_UILibrary/Dropdown';
import "./Toolbar.styles.sass"

const baseClass = "toolbar"

const Toolbar = ({
  // state
  isPrivateNote,
  noteTemplates,
  // actions
  onToggleNoteVisibility,
  useTemplate,
}) => {
  const [menuItem, setMenuItem] = React.useState();

  const handleTemplateSelected = (template) => {
    setMenuItem();
    useTemplate(template);
  }

  return (
    <div id="toolbar" className={`${baseClass}`}>
      <span className='ql-formats'>
        <button className="ql-bold" />
        <button className="ql-italic" />
        <button className="ql-clean" />
      </span>
      <div className='toolbar__actions-container'>
        {noteTemplates && (
          <div className='toolbar__template-container'>
            <HtmlTooltip
              open={menuItem >= 0}
              title={
                menuItem >= 0 &&
                // styles need to be applied inline here to control the scale of the tooltip
                <div className="toolbar__template-menu-item" style={{ width: 900, padding: 20, transform: 'scale(0.4)', transformOrigin: 'top left' }}>
                  <div dangerouslySetInnerHTML={{ __html: noteTemplates[menuItem].content }} />
                </div>
              }
              placement="left-start"
            >
              <div>
                <Dropdown placeholder="Start from a template...">
                  {noteTemplates.map((template, idx) =>
                    <Dropdown.Option 
                      key={idx} 
                      value={idx} 
                      label={template.name} 
                      onMouseEnter={_ => setMenuItem(idx)} 
                      onMouseLeave={_ => setMenuItem()} 
                      onClick={_ => handleTemplateSelected(template)}
                    />
                  )}
                  <Dropdown.Option  
                    value={null}
                    label={"No Template"}
                    onMouseEnter={_ => setMenuItem()} 
                    onClick={_ => handleTemplateSelected()}
                  />
                </Dropdown>
              </div>
            </HtmlTooltip>
          </div>
        )}
        <div className='app-form form-field app-form__check-box'>
          <label htmlFor='toggle-private'>Private note</label>
          <MuiCheckbox id="toggle-private" checked={isPrivateNote} onClick={() => onToggleNoteVisibility()}/>
        </div>
      </div>
    </div>
  )
}

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    maxWidth: 360,
    maxHeight: 400,
    overflow: 'hidden',
    border: '1px solid #dadde9',
    boxShadow: theme.shadows[1],
    padding: 0,
    background: '#fff',
    color: 'grey'
  },
}))(Tooltip);

export { Toolbar }